import { Capacitor } from '@capacitor/core';

const MOBILE_UA_REGEX = /android|ipad|iphone|ipod|ios/i;
const NATIVE_UA_MARKER = 'Mobile App';

function readUserAgent() {
  if (typeof navigator === 'undefined') {
    return '';
  }
  return navigator.userAgent || navigator.vendor || '';
}

/** Capacitor native shell or legacy Flutter `Mobile App` UA marker. */
export function isNativeApp() {
  return Capacitor.isNativePlatform() || readUserAgent().includes(NATIVE_UA_MARKER);
}

/** True for any phone/tablet — native shell **or** mobile web browser. */
export function isMobileDevice() {
  return isNativeApp() || MOBILE_UA_REGEX.test(readUserAgent());
}

/**
 * Three-bucket label used by analytics & GTM payloads.
 * Kept here so the regex + native check live in one place.
 */
export function getClientDeviceType() {
  if (isNativeApp()) {
    return 'mobile_app';
  }
  if (MOBILE_UA_REGEX.test(readUserAgent())) {
    return 'web_responsive';
  }
  return 'desktop';
}
